import register from '@kpsys/angularjs-register';
import AddClassOnHoverDirective from './kp-add-class-on-hover.directive';

import AutoFillSyncDirective from './kp-auto-fill-sync.directive';
import CompiledContentDirective from './kp-compiled-content.directive';
import HrefDirective from './kp-href.directive';
import OnClickOutsideDirective from './kp-on-click-outside.directive';
import OnOverflowDirective from './kp-on-overflow.directive';
import OnTransitionEndDirective from './kp-on-transition-end.directive';
import KpYearValidationDirective from './kp-year-validation.directive';
import KpSubmitByEnterDirective from './kp-submit-by-enter.directive';
import PreventFocusDirective from './prevent-focus.directive';
import KpOnScrollDirective from './kp-on-scroll.directive';
import KpOnErrorDirective from './kp-on-error.directive';
import KpScrollUpDirective from './kp-scroll-up.directive';
import JpLoadingDirective from './jp-loading/jp-loading.directive';
import {KpEqualsValidationDirective} from './kp-equals-validation';
import KpInjectToScopeDirective from './kp-inject-to-scope.directive';
import KpBetaFeatureDirective from './kp-beta-feature/kp-beta-feature.directive';

/**
 * @ngdoc module
 * @name portaro.directives
 * @module portaro.directives
 */

export default register('portaro.directives')
    .directive(AutoFillSyncDirective.directiveName, AutoFillSyncDirective)
    .directive(CompiledContentDirective.directiveName, CompiledContentDirective)
    .directive(OnOverflowDirective.directiveName, OnOverflowDirective)
    .directive(OnTransitionEndDirective.directiveName, OnTransitionEndDirective)
    .directive(OnClickOutsideDirective.directiveName, OnClickOutsideDirective)
    .directive(AddClassOnHoverDirective.directiveName, AddClassOnHoverDirective)
    .directive(HrefDirective.directiveName, HrefDirective)
    .directive(KpYearValidationDirective.directiveName, KpYearValidationDirective)
    .directive(KpSubmitByEnterDirective.directiveName, KpSubmitByEnterDirective)
    .directive(PreventFocusDirective.directiveName, PreventFocusDirective)
    .directive(KpOnScrollDirective.directiveName, KpOnScrollDirective)
    .directive(KpOnErrorDirective.directiveName, KpOnErrorDirective)
    .directive(KpScrollUpDirective.directiveName, KpScrollUpDirective)
    .directive(JpLoadingDirective.directiveName, JpLoadingDirective)
    .directive(KpEqualsValidationDirective.directiveName, KpEqualsValidationDirective)
    .directive(KpInjectToScopeDirective.directiveName, KpInjectToScopeDirective)
    .directive(KpBetaFeatureDirective.directiveName, KpBetaFeatureDirective)
    .name();